import { gql } from '@apollo/client';

export const BULK_APPLY_STRATEGIES = gql`
  mutation BulkApplyStrategies($input: BulkApplyStrategiesInput!) {
    bulkApplyStrategies(input: $input) {
      success
      error
      updatedCount
      skippedCount
      failedCount
      updatedIds
      skippedIds
      failedIds
    }
  }
`;
